module.exports = __webpack_public_path__ + "img/20191228130239368.07bf46a3.jpg";